<template>
  <v-badge
    bordered
    overlap
    icon="fas fa-ban"
    :value="question.invalidated"
    color="bg-gray-400 text-black"
  >
    <div
      class="feedback-item font-weight-bolder pointer-on-hover w-100"
      :class="{
        'success' : successResult,
        'error' : errorResult,
        'challenge' : !showResult && question.user_answer,
        'is-active' : isActive
      }"

      @click="$emit('click')"
    >
      <div class="text-black">
        {{ question.key + 1 }}
      </div>
      <div class="bg-dark-modal feedback-item__answer text-uppercase pt-1">
        {{ question.user_answer }}
      </div>
    </div>
  </v-badge>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'MarkerComponentInput',
  props: {
    challenge:{
      type: Object,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    }
  },
  computed:{
    ...mapGetters(['authUser']),
    successResult(){
      return this.answerIsCorrect && this.showResult;
    },
    errorResult(){
      return !this.successResult && this.showResult;
    },
    showResult(){
      return this.authUser.is_manager || (this.challenge.finished_at && this.challenge.show_result);
    },
    answerIsCorrect(){
      return this.question.answer === this.question.user_answer
    }
  },
}
</script>

<style scoped>

.feedback-item {
  background-color: #6D6E71;
  border-radius: 6px;
  padding: 3px;
  font-size: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 50px
}

.feedback-item.is-active {
  border: 1px solid #fff;
  box-sizing: border-box;
}

.feedback-item__answer {
  border-radius: 0 0 3px 3px;
  height: 20px;
}
</style>
